import { Component } from '@angular/core';

@Component({
  selector: 'app-layer-page',
  templateUrl: './layer-page.component.html',
  styleUrls: ['./layer-page.component.scss']
})
export class LayerPageComponent {

}
